// @flow
import React, { Component } from 'react'
import { translations, translateFunc } from '../../shared/localize'
import Spinner from '../controls/Spinner'
import Modal from '../FieldSet/Modal'
import styled, { type StyledComponent } from 'styled-components'
import postJson from '../../services/postJson'

export const Link: StyledComponent<Object, any, any> = styled.a`
  ${({ isLocked }: Object) =>
    isLocked &&
    `
    color: gray;
    text-decoration: none;
  `};
`

const t = translateFunc(translations.provider_publics.public_link)

type Props = {|
  id: number,
  actionUrl: string,
  actionName: string,
  provider: 'vk' | 'facebook',
  instructions: boolean,
  isLocked: boolean,
  onAjaxStarted: () => void,
  onAjaxFinished: () => void,
  onAccessChange?: (number, string) => void
|}

type State = {|
  isLoading: boolean,
  haveActed: boolean,
  isModalOpen: boolean,
  message: string
|}

export default class PublicLink extends Component<Props, State> {
  state = {
    isLoading: false,
    haveActed: false,
    isModalOpen: false,
    message: ''
  }

  handleClick(event: any) {
    event.preventDefault()

    const { haveActed, isLoading } = this.state
    const {
      actionUrl,
      onAjaxStarted,
      onAjaxFinished,
      isLocked,
      id,
      onAccessChange,
      provider
    } = this.props

    if ((isLoading || haveActed || isLocked) && !(provider === 'vk' && haveActed)) return

    onAjaxStarted()

    this.setState({ isLoading: true }, () =>
      postJson(actionUrl)
        .done((response) => {
          const { redirect, message, adsAccess } = response.data

          if (redirect) {
            window.location.href = redirect
            return
          }

          if (adsAccess) {
            onAccessChange && onAccessChange(id, adsAccess)
          }

          this.setState({ haveActed: true, isModalOpen: true, message: message })
        })
        .fail(() => window.alert(t('ajax_error')))
        .always(() => {
          onAjaxFinished()
          this.setState({ isLoading: false })
        })
    )
  }

  getInstructions() {
    const { provider } = this.props

    switch (provider) {
      case 'vk':
        return t('vk_instructions')
      case 'facebook':
        return t('facebook_instructions')
    }
  }

  renderModal() {
    const { instructions } = this.props
    const { isModalOpen, message } = this.state

    return (
      <Modal
        isOpen={isModalOpen}
        btnText={t('btn_text')}
        hideBtn={!instructions}
        header={message}
        maxWidth={500}
        onClose={() => {
          this.setState({ isModalOpen: false })
        }}
      >
        {instructions && <div dangerouslySetInnerHTML={{ __html: this.getInstructions() }} />}
      </Modal>
    )
  }

  render() {
    const { actionName, isLocked } = this.props
    const { isLoading } = this.state

    return (
      <span>
        <Link isLocked={isLocked} href="#" onClick={(event) => this.handleClick(event)}>
          {actionName}
        </Link>
        {isLoading && <Spinner className="spinner" />}
        {this.renderModal()}
      </span>
    )
  }
}
